<main class="main-wrap">
    <app-blog-details-component></app-blog-details-component>
</main>
